/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Frontrow_HeadlineInputs */

const en_frontrow_headline = /** @type {(inputs: Frontrow_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The front row is for the customer.`)
};

/**
* | output |
* | --- |
* | "The front row is for the customer." |
*
* @param {Frontrow_HeadlineInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const frontrow_headline = /** @type {((inputs?: Frontrow_HeadlineInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Frontrow_HeadlineInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_frontrow_headline(inputs)
});